module.exports = __webpack_public_path__ + "ui-static/img/not-found-mountain_light.aa7706e6.svg";